module.exports = __webpack_public_path__ + "img/service_1.1c17ec6b.jpg";